import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';

const BackgammonGuidelineModal = ({showGuidelines, setShowGuidelines}) => {
  if (!showGuidelines) return null;
  return (
    <Modal
      type={MODAL_TYPE.SMALL}
      showModal={showGuidelines}
      onCloseModal={() => setShowGuidelines(false)}
      title='Guidelines'
      text='Backgammon Game Display'
      isDark
      showPrimaryButton={false}
      showSecondaryButton={false}
      onClickPrimaryButton={() => setShowGuidelines(false)}
      onClickSecondaryButton={() => {}}
      primaryButtonText=''
      secondaryButtonText=''
      className='guideline-modal'
      content={
        <div
          className='flex items-center justify-center rounded-lg p-[24px_16px]'
          style={{
            background: '#262626',
            minHeight: '200px',
            width: '100%'
          }}>
          <p className='text-lg font-bold text-white'>Coming soon..</p>
        </div>
      }
    />
  );
};

BackgammonGuidelineModal.propTypes = {
  showGuidelines: PropTypes.bool.isRequired,
  setShowGuidelines: PropTypes.func.isRequired
};

export default React.memo(BackgammonGuidelineModal);
